import { useEffect, useState, useCallback } from 'react';
import { Box, Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import useApiService from '../../component/hooks/useApiService';
import { useAppSnackbar } from '../../component/providers/SnackbarProvider';

import { apiUrls } from '../../constans/apiUrls';
import stringFormat from '../../component/common/stringFormat';


const TicketStatePage = ({ data, close, adminPanelAction, openType }) => {


    const { executePost } = useApiService();
    const [dataModel, setDataModel] = useState({});
    const { showSnackbar } = useAppSnackbar();

    const setField = (fields) => {
        setDataModel(oldState => ({ ...oldState, ...fields }));
    };

    useEffect(() => {
        if (data) { getDataByGrid(); }
    }, []);




    const getDataByGrid = () => {
        if (data) {
            setField(data);

        }
    }

    const approveTicket = async () => {
        try {
            await executePost({
                url: stringFormat(apiUrls.TicketApprove, dataModel?.id),
                data: dataModel?.id,
            });
            close(true);
        } catch (err) {
            showSnackbar('Ticket onaylanamadı. Hata: ' + (err?.message || 'Bilinmeyen hata'), 'error');
            close(false);
        }
    };

    const rejectTicket = async () => {
        try {
            await executePost({
                url: stringFormat(apiUrls.TicketReject, dataModel?.id),
                data: dataModel?.id,
            });
            close(true);
        } catch (err) {
            showSnackbar('Ticket iptal edilemedi. Hata: ' + (err?.message || 'Bilinmeyen hata'), 'error');
            close(false);
        }
    };

    const completeTicket = async () => {
        try {
            await executePost({
                url: stringFormat(apiUrls.TicketComplete, dataModel?.id),
                data: dataModel?.id,
            });
            close(true);
        } catch (err) {
            showSnackbar('Ticket tamamlanamadı. Hata: ' + (err?.message || 'Bilinmeyen hata'), 'error');
            close(false);
        }
    };

    const filteredActionList = () => {
        switch (openType) {
            case "Approve":
                return actionList.filter(action => action.name === 'Approve' || /* action.name === 'Documents' || */ action.name === 'Cancel');
            case "Reject":
                return actionList.filter(action => action.name === 'Reject' || /* action.name === 'Documents' || */ action.name === 'Cancel');
            case "Complete":
                return actionList.filter(action => action.name === 'Complete' || /* action.name === 'Documents' || */ action.name === 'Cancel');
            default:
                return actionList.filter(action => action.name === 'Save' ||  /* action.name === 'Documents' || */  action.name === 'Cancel');
        }
    }

    const actionList = [
        {
            name: 'Approve',
            label: "Evet",
            order: 3
        },
         {
            name: 'Complete',
            label: "Evet",
            order: 3
        },
        {
            name: 'Reject',
            label: "Evet",
            order: 3
        },

        { name: 'Cancel', variant: 'text', label: "Hayır", order: 0 },
        ...getadminPanelAction()

    ]

    function getadminPanelAction() {
        return adminPanelAction ? [
            {
                name: adminPanelAction.name,
                label: adminPanelAction.label,
                order: 3
            }
        ] : [];
    }
    const onActionClick = useCallback((action) => {
        if (action.name === 'Approve') {
            approveTicket();
        }
        else if (action.name === 'Reject') {
            rejectTicket();
        }
        else if (action.name === 'Complete') {
            completeTicket();
        }
        else if (action.name == 'Cancel') {
            close && close();
        }
    }, [dataModel]);

    return (
        <Card sx={{ display: 'flex', flexDirection: 'column', height: 'auto' }}>
            <Box sx={{ flex: 1, overflow: 'auto', }}>
                <CardContent
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(1fr, 1fr))',
                        gap: 2,
                    }}
                >
                    {openType === "Reject" &&

                        <Typography sx={{ alignContent: "center", textAlign: "center" }}>Ticket reject edilecektir,onaylıyor musunuz ?</Typography>
                    }
                    {openType === "Approve" &&

                        <Typography sx={{ alignContent: "center", textAlign: "center" }}>Ticket approve edilecektir,onaylıyor musunuz ?</Typography>
                    }
                     {openType === "Complete" &&

                        <Typography sx={{ alignContent: "center", textAlign: "center" }}>Ticket tamamlanacaktır ,onaylıyor musunuz ?</Typography>
                    }
                </CardContent>

            </Box>
            <CardActions
                sx={{
                    justifyContent: 'flex-end',
                    borderTop: '1px solid #e0e0e0',
                    p: 2,
                    backgroundColor: '#fff',
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 1,
                }}
            >

                {filteredActionList()
                    .sort((a, b) => a.order - b.order)
                    .map((action) => (
                        <Button
                            key={action.name}
                            variant={action.variant || 'contained'}
                            onClick={() => onActionClick(action)}
                            sx={{

                                ...(action.variant && {
                                    textTransform: 'none',
                                    color: '#1976d2',
                                    border: 'none',
                                    fontWeight: '500',
                                    '&:hover': {
                                        backgroundColor: '#e3f2fd'
                                    }
                                }),

                                ...(!action.variant && {
                                    textTransform: 'none',
                                    backgroundColor: '#1976d2',
                                    color: 'white',
                                    borderRadius: '10px',
                                    fontWeight: 'bold'
                                })
                            }}
                        >
                            {action.label}
                        </Button>
                    ))}
            </CardActions>
        </Card>

    );
};

export default TicketStatePage;
